import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { vehicleModels } from "./vehicle-models";

// ============================================================================
// vehicle_generations — โฉม/ช่วงปี
// ============================================================================
export const vehicleGenerations = sqliteTable("fleet_vehicle_generations", {
  id: text("id").primaryKey(), // ULID
  modelId: text("model_id").notNull().references(() => vehicleModels.id),
  name: text("name").notNull(),
  yearStart: integer("year_start"),
  yearEnd: integer("year_end"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleGeneration = typeof vehicleGenerations.$inferSelect;
export type NewVehicleGeneration = typeof vehicleGenerations.$inferInsert;
